import { render, staticRenderFns } from "./EntityMedia.vue?vue&type=template&id=00e80d34&scoped=true&"
import script from "./EntityMedia.vue?vue&type=script&lang=js&"
export * from "./EntityMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e80d34",
  null
  
)

export default component.exports